<template>
	<div class="UT">
		<card class="addTest">
			<div class="fields row ">				
				<base-input
				class="col-md-12 col-lg-3 mb-2 "
				placeholder="Название теста"
				v-model="objNewTest.testname"
				autocomplete="off"
				></base-input>
				<div class="col-md-12 col-lg-3 mb-2 ">
					<textarea
					class="form-control"
					placeholder="Запрос"
					v-model="objNewTest.req"
					autocomplete="off"
					style="resize: auto; max-height:320px;"
					></textarea>
				</div>
				<div class="col-md-12 col-lg-3 mb-2 ">
					<textarea
					class="form-control "
					placeholder="Ожидаемый ответ"
					v-model="objNewTest.expected_response"
					autocomplete="off"
					style="resize: auto; max-height:320px;"
					></textarea>
				</div>
				<el-select
					class="col-md-12 col-lg-3 mb-2  select-primary overflow-overlay"
					size="large"
					placeholder="Функция проверки"
					v-model="objNewTest.check_function"
				>
					<el-option
						v-for="(el_opt, el_index) in masCheckFunctions"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
				<div class="d-flex px-3 mb-3">
					<button class="btnChange btn btn-simple btn-success mt-0 mr-2" @click="AddTest()">Создать тест</button>
					<button class="btnChange btn btn-simple btn-primary mt-0 " @click="StartTestNoCreate()">Запустить тест</button>
				</div>
			</div>
		</card>

		<!--pre>{{ ApiData }}</pre-->

		<card>
			<button class="btnStart btn btn-simple btn-success col-sm-12 col-lg-2 m-0 mb-3" @click="StartTest()">Запустить тесты</button>
			<el-table ref="multipleTable" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName" :data="ApiData">
				<el-table-column
					type="selection"
					width="55">
				</el-table-column>
				<el-table-column
					min-width="55"
					sortable
					label="№"
					property="id"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Название теста"
					property="testname"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Запрос"
					property="req"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Ответ ожидаемый"
					property="expected_response"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Проверка ответа"
					property="check_function"
				></el-table-column>
				<el-table-column
					min-width="80"
					label="Удалить"
					property="del"
				>
					<template v-slot="scope">
						<button class="btn btn-simple btn-danger" @click="DelTest(scope.row.id)">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
					</template>	
				</el-table-column>
			</el-table>
		</card>

	</div>
</template>
<script>
import { Select, Option, Table, TableColumn } from 'element-ui';

export default {
	name: 'unittests-page',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			ApiData: [],
			objNewTest:{
				'testname':'',
				'req':'',
				'expected_response':'',
				'check_function':'',
			},
			masTableSelection: [],
			masCheckFunctions: [
				{value: '=', label: '=',},
				{value: 'data_exists', label: 'data_exists',},
			],
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('GET',{obj:'AutoTest',flt:{'test_id':-1}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		AddTest(){
			this.$GVO.ApiCall('INS',{obj:'AutoTest',iData:{...this.objNewTest}})
			.then((objApi) => {
				if(objApi.success === true){
					this.objNewTest = {
						'testname':'',
						'req':'',
						'expected_response':'',
						'check_function':'',
					}
					this.getApiData();
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		StartTest(){
			if(this.masTableSelection.length>0){
				for (let i = 0; i < this.masTableSelection.length; i++) {
					//console.log(this.masTableSelection[i]);
					let objTest = this.$GVO.unlinkObject(this.masTableSelection[i]);
					this.$GVO.axiosSend(this.masTableSelection[i].req)
					.then((objApi) => {
						//console.log(objApi);
						//console.log(objTest);
						this.CheckTest(objTest,objApi);
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			}
		},
		StartTestNoCreate(){
			//this.objNewTest
			if(this.objNewTest.req !=''){
				let objTest = this.$GVO.unlinkObject(this.objNewTest);
					this.$GVO.axiosSend(this.objNewTest.req)
					.then((objApi) => {
						//console.log(objApi);
						//console.log(objTest);
						alert(this.CheckTest(objTest,objApi,true));
					}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		DelTest(test_id){
			this.$GVO.ApiCall('DEL',{obj:'AutoTest',flt:{'id':test_id}})
			.then((objApi) => {
				if(objApi.success === true){
					this.getApiData();
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		CheckTest(objTestData,objRetData,bSingle=false){
			let bRes = false;

			if(objTestData.check_function == '='){
				if(JSON.stringify(objRetData) === objTestData.expected_response) bRes = true;
			}else if(objTestData.check_function == 'data_exists'){
				if(objRetData.result.success == true && objRetData.result.data.length > 0) bRes = true;
			}else{
				return bRes;
			}

			if(!bSingle){
				for (let i = 0; i < this.ApiData.length; i++) {
					if(this.ApiData[i].id == objTestData.id){
						this.ApiData[i]['test_result'] = bRes;
						this.toggleSelection([this.ApiData[i]]);
					}
				}
				this.$refs.multipleTable.clearSelection();
				//this.$refs.multipleTable.doLayout();
			}

			return bRes;
		},
		handleSelectionChange(val) {
			this.masTableSelection = val;
		},
		tableRowClassName({row}) {
			if (typeof row.test_result != 'undefined') {
				if(row.test_result==false){
					return 'table-danger';
				} else if (row.test_result==true) {
					return 'table-success';
				}
			}
			return '';
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
	},
	mounted() {
		this.getApiData();
	}
};
</script>

<style scoped>

.fields {display: flex; flex-wrap: wrap; flex-direction: row; align-items: flex-end;}
</style>
